<div class="sc-info-box">
  <sc-icon class="sc-info-box__icon" [icon]="icon"></sc-icon>
  <div class="sc-info-box__content">
    <div class="sc-info-box__content__title" *ngIf="!!title">{{title}}</div>
    <div class="sc-info-box__content__external">
      <ng-content></ng-content>
    </div>
  </div>
</div>
